import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { colors } from '../styles/colors';
import { fonts } from '../styles/fonts';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, loading: authLoading } = useAuth();

  if (authLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    const success = await login(email, password);
    if (success) {
      // Navigation will happen automatically due to auth state change
    }
    
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div className="colorline"></div>
      <div style={styles.loginBox}>
        <h1 style={styles.title}>Trampos Admin</h1>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
              placeholder="admin@trampos.co"
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Senha:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
              placeholder="password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={styles.button}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: colors.background,
  },
  loginBox: {
    backgroundColor: colors.white,
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '400px',
  },
  title: {
    textAlign: 'center' as const,
    marginBottom: '2rem',
    color: colors.primary,
    fontSize: fonts.sizes['4xl'],
    fontWeight: fonts.weights.semibold,
    fontFamily: fonts.secondary,
  },
  form: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
  inputGroup: {
    marginBottom: '1rem',
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    color: colors.text,
    fontWeight: fonts.weights.semibold,
    fontFamily: fonts.body,
    fontSize: fonts.sizes.sm,
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    border: `2px solid ${colors.border}`,
    borderRadius: '6px',
    fontSize: fonts.sizes.base,
    fontFamily: fonts.body,
    boxSizing: 'border-box' as const,
    transition: 'border-color 0.2s',
    '&:focus': {
      borderColor: colors.primary,
      outline: 'none',
    },
  },
  button: {
    backgroundColor: colors.primary,
    color: colors.white,
    padding: '0.875rem',
    border: 'none',
    borderRadius: '6px',
    fontSize: fonts.sizes.base,
    fontFamily: fonts.body,
    fontWeight: fonts.weights.semibold,
    cursor: 'pointer',
    marginTop: '1rem',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: colors.secondary,
    },
  },
};

export default Login;
